import { render, staticRenderFns, recyclableRender, components } from "./uploadImage.vue?vue&type=template&id=c2c72d8c&scoped=true&"
var renderjs
import script from "./uploadImage.vue?vue&type=script&lang=js&"
export * from "./uploadImage.vue?vue&type=script&lang=js&"
import style0 from "./uploadImage.vue?vue&type=style&index=0&id=c2c72d8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../办公/HBuilderX.3.8.12.20230817/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2c72d8c",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "components/uploadImage/uploadImage.vue"
export default component.exports